var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgPlayerB4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 145,
    viewBox: "0 0 100 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9172 27.6439L46.9618 20.8993L55.1019 20L63.242 23.1475L69.121 31.241L75 36.187V40.6835L70.0255 43.3813L69.121 44.7302L70.0255 49.2266L69.121 54.1727L65.5032 58.6691L60.9809 59.5683L57.3631 62.7158L55.1019 64.5144V66.313L72.2866 82.0504L75 86.9964V96.4388L69.121 106.781L64.5987 115.773L67.3121 145H11.2357H0V62.7158L25.707 57.3201L34.7516 56.4209L36.5605 51.0252L34.7516 46.9784L32.9427 38.8849L33.8471 33.0396L37.9172 27.6439Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPlayerB4);
export default __webpack_public_path__ + "static/media/bg_player_b4.31c842ca54d27e556ffa166e200c5026.svg";
export { ForwardRef as ReactComponent };